<template>
  <!-- 桌面端完整显示 -->
  <el-card v-if="!isMobile" class="schedule-card" shadow="hover">
    <div slot="header" class="card-header">
      <div class="header-content">
        <i class="el-icon-s-order header-icon"></i>
        <span class="header-text">教练排班信息</span>
      </div>
    </div>

    <div class="schedule-content">
      <div class="schedule-info">
        <div class="info-item">
          <i class="el-icon-user info-icon"></i>
          <div class="info-content">
            <div class="info-label">教练</div>
            <div class="info-value">{{ coachScheduleInfo.coachName }}</div>
          </div>
        </div>

        <div class="info-item">
          <i class="el-icon-date info-icon"></i>
          <div class="info-content">
            <div class="info-label">日期</div>
            <div class="info-value">{{ coachScheduleInfo.date }}</div>
          </div>
        </div>

        <div class="info-item">
          <i class="el-icon-user-solid info-icon"></i>
          <div class="info-content">
            <div class="info-label">最大同时训练人数</div>
            <div class="info-value">
              <el-tag type="info" size="medium">
                {{ coachScheduleInfo.maxStudents }}人/时段
              </el-tag>
            </div>
          </div>
        </div>

        <div class="info-item">
          <i class="el-icon-time info-icon"></i>
          <div class="info-content">
            <div class="info-label">已排班时段</div>
            <div class="scheduled-slots">
              <el-tag
                  v-for="(slot, index) in coachScheduleInfo.timeSlots"
                  :key="index"
                  type="success"
                  size="small"
                  class="scheduled-tag"
              >
                {{ slot }}
              </el-tag>
              <span v-if="!coachScheduleInfo.timeSlots || coachScheduleInfo.timeSlots.length === 0" class="no-schedule">
                该日期暂无排班
              </span>
            </div>
          </div>
        </div>

        <div v-if="coachScheduleInfo.remark" class="info-item">
          <i class="el-icon-document info-icon"></i>
          <div class="info-content">
            <div class="info-label">排班备注</div>
            <div class="schedule-remark">
              {{ coachScheduleInfo.remark }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-card>

  <!-- 移动端折叠显示 -->
  <div v-else class="mobile-schedule-info">
    <div class="schedule-header" @click="$emit('toggle')">
      <div class="schedule-title">
        <i class="el-icon-s-order"></i>
        <span>教练排班信息</span>
      </div>
      <i :class="['el-icon-arrow-down', { 'expanded': expanded }]" class="toggle-icon"></i>
    </div>

    <transition name="slide-fade">
      <div v-show="expanded" class="schedule-content">
        <div class="schedule-item">
          <span class="schedule-label">教练：</span>
          <span class="schedule-value">{{ coachScheduleInfo.coachName }}</span>
        </div>
        <div class="schedule-item">
          <span class="schedule-label">最大人数：</span>
          <span class="schedule-value">{{ coachScheduleInfo.maxStudents }}人/时段</span>
        </div>
        <div class="schedule-item">
          <span class="schedule-label">已排班时段：</span>
          <div class="scheduled-slots">
            <el-tag
                v-for="(slot, index) in coachScheduleInfo.timeSlots"
                :key="index"
                type="success"
                size="small"
                class="scheduled-tag"
            >
              {{ slot }}
            </el-tag>
            <span v-if="!coachScheduleInfo.timeSlots || coachScheduleInfo.timeSlots.length === 0" class="no-schedule">
              该日期暂无排班
            </span>
          </div>
        </div>
        <div v-if="coachScheduleInfo.remark" class="schedule-item">
          <span class="schedule-label">排班备注：</span>
          <span class="schedule-value remark">{{ coachScheduleInfo.remark }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CoachScheduleInfo',
  props: {
    coachScheduleInfo: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
/* 桌面端排班信息样式 */
.schedule-card {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.schedule-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.schedule-info {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.info-icon {
  font-size: 16px;
  color: #409EFF;
  margin-top: 2px;
  flex-shrink: 0;
}

.info-content {
  flex: 1;
}

.info-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 4px;
}

.info-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.scheduled-slots {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.no-schedule {
  color: #909399;
  font-style: italic;
  font-size: 13px;
}

.schedule-remark {
  background: rgba(248, 249, 250, 0.7);
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
  line-height: 1.4;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

/* 移动端排班信息 */
.mobile-schedule-info {
  border: 1px solid rgba(235, 238, 245, 0.5);
  border-radius: 8px;
  overflow: hidden;
  background: rgba(248, 249, 250, 0.8);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: rgba(248, 249, 250, 0.5);
  cursor: pointer;
}

.schedule-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.toggle-icon {
  transition: transform 0.3s ease;
  color: #909399;
}

.toggle-icon.expanded {
  transform: rotate(180deg);
}

.schedule-content {
  padding: 0 16px 12px;
}

.schedule-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(240, 240, 240, 0.5);
}

.schedule-item:last-child {
  border-bottom: none;
}

.schedule-label {
  font-size: 13px;
  color: #909399;
}

.schedule-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.schedule-value.remark {
  background: rgba(248, 249, 250, 0.7);
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.4;
}

/* 动画效果 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
